/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GeoJsonProperties } from './GeoJsonProperties';
import {
    GeoJsonPropertiesFromJSON,
    GeoJsonPropertiesFromJSONTyped,
    GeoJsonPropertiesToJSON,
} from './GeoJsonProperties';
import type { Geometry } from './Geometry';
import {
    GeometryFromJSON,
    GeometryFromJSONTyped,
    GeometryToJSON,
} from './Geometry';

/**
 * GeoJson object. Object containing a position, linestring or polygon or a set of child shapes. Based on http://geojson.org/ Notice it can be a (nested) feature collection
 * @export
 * @interface GeoJson
 */
export interface GeoJson {
    /**
     * 
     * @type {GeoJsonProperties}
     * @memberof GeoJson
     */
    properties: GeoJsonProperties;
    /**
     * 
     * @type {Array<GeoJson>}
     * @memberof GeoJson
     */
    features?: Array<GeoJson>;
    /**
     * 
     * @type {Geometry}
     * @memberof GeoJson
     */
    geometry?: Geometry;
    /**
     * 
     * @type {string}
     * @memberof GeoJson
     */
    type: GeoJsonTypeEnum;
}


/**
 * @export
 */
export const GeoJsonTypeEnum = {
    FeatureCollection: 'FeatureCollection',
    Feature: 'Feature'
} as const;
export type GeoJsonTypeEnum = typeof GeoJsonTypeEnum[keyof typeof GeoJsonTypeEnum];


/**
 * Check if a given object implements the GeoJson interface.
 */
export function instanceOfGeoJson(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "properties" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function GeoJsonFromJSON(json: any): GeoJson {
    return GeoJsonFromJSONTyped(json, false);
}

export function GeoJsonFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoJson {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'properties': GeoJsonPropertiesFromJSON(json['properties']),
        'features': !exists(json, 'features') ? undefined : ((json['features'] as Array<any>).map(GeoJsonFromJSON)),
        'geometry': !exists(json, 'geometry') ? undefined : GeometryFromJSON(json['geometry']),
        'type': json['type'],
    };
}

export function GeoJsonToJSON(value?: GeoJson | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'properties': GeoJsonPropertiesToJSON(value.properties),
        'features': value.features === undefined ? undefined : ((value.features as Array<any>).map(GeoJsonToJSON)),
        'geometry': GeometryToJSON(value.geometry),
        'type': value.type,
    };
}

